// this middleware is used for fetching categories.json file from public/data/ 
// in future only this file will requird to change for API integration

export const getServices = async () => {
  const response = await fetch("/data/services.json");

  if (!response.ok) {
    throw new Error("Failed to fetch Services");
  }

  return response.json();
};
